import { Link } from "react-router";
import SocialMediaIcons from "./SocialMediaIcons";

const Footer: React.FC<{}> = () => {
  return (
    <footer className="flex flex-col items-center lg:flex-row-reverse lg:justify-between lg:items-start mx-5 mt-8 py-8 border-t-[.5px] border-t-divider dark:border-t-divider-dark">
      <div className="mb-12">
        <h4 className="text-grey-dark uppercase text-center lg:text-right font-bold mb-1">
          Partners
        </h4>
        {/* {partners.map(partner => <a key={partner.id} href={partner.website}><img src={partner.avatar} /></a>)} */}
        <a href="https://www.activision.com/">
          <img
            src="/assets/logo/Activision_Logo.png"
            alt="Activision logo"
            className="w-1/2 lg:w-auto lg:h-8 mx-auto lg:mx-0 invert dark:invert-0"
          />
        </a>
      </div>
      <div className="hidden lg:block pt-8">
        <SocialMediaIcons colour="#3A3E41" />
      </div>
      <div className="flex flex-col items-center lg:items-start gap-y-4 lg:max-w-sm">
        <h4 className="text-grey-dark uppercase font-bold mb-1">Part of</h4>
        <div className="flex items-center justify-around gap-5">
          <a href="https://jiwe.team">
            <svg
              id="Layer_2"
              data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 212.6 85.04"
              className="h-12"
            >
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M50.92,44.37,47.1,32.7,43,21,34,7.43l-6.58,3.32L20,21.46l-7.7,10.48,1.58,20.89.52.21L20.9,71.26l11.44.91,9-6.32,4.41-2.36ZM37.26,58.81,33.7,56.59,28.13,45l2.93-15.87,8.54,7.59,8.85,7.9Zm3.43-36.58L47,40.16,31.74,26.06l2.47-13.45ZM29,12.5l2.72-1.19L28.41,27.67,25.33,44l-4.25.76L14.37,32.2l7.33-9.91ZM14.88,38.05l4,7.89-2.43,3.53ZM21,47l4.73-.39L30.9,57.34,22.38,67.4,16.54,52.9ZM31.7,69.88,24.53,69l8.54-9.64,3.42,2,2.64,3.22Zm12.34-8-2.85,1.15-1.94-2.69,7.81-10.32Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M62.36,70.8l1.39-1.66a4.7,4.7,0,0,0,2.93,1.08c.69,0,1-.23,1-.62s-.31-.49-1.54-.77c-1.92-.44-3.4-1-3.4-2.79s1.39-2.92,3.49-2.92A5.67,5.67,0,0,1,70,64.32l-1.25,1.77a4.47,4.47,0,0,0-2.53-.89c-.61,0-.9.24-.9.58s.31.59,1.57.87c2.07.43,3.36,1,3.36,2.68,0,1.87-1.44,3-3.66,3A6.29,6.29,0,0,1,62.36,70.8Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M86.41,65.51H83.79V63.28h7.74v2.23H88.91v6.63h-2.5Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M105.36,68.21V63.28h2.51v4.8a1.73,1.73,0,1,0,3.43,0v-4.8h2.51v4.93a4.23,4.23,0,0,1-8.45,0Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M128.42,63.28h3.31c3.1,0,5.29,1.83,5.29,4.42s-2.19,4.44-5.29,4.44h-3.31Zm3.72,6.59a2.16,2.16,0,1,0,0-4.32h-1.21v4.32Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M151.29,63.28h2.51v8.86h-2.51Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M168,67.7a4.84,4.84,0,1,1,4.83,4.6A4.77,4.77,0,0,1,168,67.7Zm7.08,0A2.25,2.25,0,1,0,172.86,70,2.31,2.31,0,0,0,175.11,67.7Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M191.14,70.8l1.39-1.66a4.7,4.7,0,0,0,2.93,1.08c.69,0,1-.23,1-.62s-.31-.49-1.54-.77c-1.92-.44-3.4-1-3.4-2.79s1.39-2.92,3.49-2.92a5.67,5.67,0,0,1,3.72,1.2l-1.25,1.77A4.47,4.47,0,0,0,195,65.2c-.61,0-.9.24-.9.58s.31.59,1.57.87c2.07.43,3.36,1,3.36,2.68,0,1.87-1.44,3-3.65,3A6.3,6.3,0,0,1,191.14,70.8Z"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="89.5 42.4 85.2 42.45 81 41.98 76.8 42.28 72.6 42.4 68.56 42.12 68.2 38.53 68.54 34.95 73 34.52 73.07 30.41 68.55 30.13 63.71 30.06 63.64 34.39 64.21 38.53 64.19 42.67 64.04 46.65 68.17 46.93 72.46 46.84 76.75 46.91 81.04 46.81 85.33 47 89.62 46.51 93.83 46.73 93.75 42.55 93.8 38.3 93.95 34.04 94.11 29.79 93.82 25.53 93.6 21.27 93.85 17.01 93.89 12.77 89.19 12.53 89.64 16.97 89.55 21.19 89.23 25.41 89.47 29.63 89.08 33.85 89.25 38.08 89.5 42.4"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="78.65 22.6 73.86 22.48 69.03 22.64 64.1 22.45 64.21 27.03 69.02 27.07 73.86 27 78.78 27.14 78.65 22.6"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M102.14,17.24,105.6,17l3.53.37V21.5l-.07,4.16-.1,4.16.42,4.16L109,38.14l0,4-3.44.19-3.72-.18.38,4.37,4.17.5,4.41-.19,4.42-.1,4.41-.11,4.42,0,4.42.18.2-4.67-3.82,0-3.58.09,0-4.12L121.25,34l.32-4.16-.21-4.16-.07-4.16.12-4,3.48.19,3.5-.41.32-4.61-4.61,0-4.42.55-4.41-.6-4.42.29-4.42.11-4.35-.06ZM116.89,42.4l-3.46.09.33-4.35,0-4.15.06-4.16.11-4.16-.43-4.16.35-4.06h2.78l.22,4.05-.25,4.16.51,4.16-.6,4.16.19,4.16Z"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="145.3 37.13 142.59 39.84 141.88 35.13 145.28 32.22 145.29 32.23 145.26 25.68 141.34 29.36 140.78 25.47 140.43 21.31 139.58 17.21 139.43 12.92 134.77 13.45 135.45 17.68 135.61 21.89 136.7 25.97 136.84 30.18 137.41 34.34 138.15 38.47 138.6 42.65 139.16 46.73 142.48 45.26 145.34 43.46 145.3 37.13"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="156.26 43.86 153.17 40.56 151.13 38.05 148.38 40.34 145.34 43.46 145.3 37.13 148.27 34.49 150.9 31.37 152.98 34.15 156.25 38.02 156.26 43.86"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="156.36 32.29 153.5 29.49 151.26 27.12 145.28 32.22 145.26 25.67 150.78 21.26 156.46 26.68 156.36 32.29"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="161.66 12.81 161.07 17.11 161.05 21.26 160.21 25.32 159.96 29.37 156.46 26.68 156.36 32.29 159.09 35.02 158.82 39.75 156.25 38.02 156.26 43.86 159.25 45.07 162.31 47.03 162.8 42.67 163.35 38.51 163.79 34.34 164.22 30.17 164.76 26 165.35 21.85 165.62 17.66 166.17 13.65 161.66 12.81"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="175.01 42.46 175.27 36.73 179.04 36.48 182.84 36.82 186.64 36.8 190.51 36.77 190.67 32.01 186.64 32.34 182.84 31.88 179.04 31.93 175.41 31.97 175.31 29.54 179.04 29.53 182.84 29.57 186.64 29.12 190.59 29.58 190.41 24.96 186.64 25.19 182.84 25.05 179.04 24.69 175.12 25.06 174.96 21.17 175.05 17.17 179.66 17.45 184.08 17.54 188.5 17.57 192.93 17.31 197.51 17.55 197.28 12.96 192.92 12.94 188.48 12.76 184.04 12.72 179.61 13.04 175.17 12.77 170.7 12.86 170.8 17.13 170.73 21.37 170.85 25.61 170.92 29.84 171 34.09 170.87 38.33 170.69 42.57 170.74 46.8 174.68 46.79 178.64 46.95 182.59 46.82 186.55 46.61 190.5 46.66 194.46 46.83 198.49 46.88 198.28 42.42 194.55 42.43 190.69 42.07 186.83 42.41 182.97 42.16 179.11 42.52 175.01 42.46"
              />
            </svg>
          </a>
          <a href="https://jiwe.io">
            <svg
              id="Layer_2"
              data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 261.21 84.77"
              className="h-12"
            >
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="138.45 42.27 134.15 42.31 129.95 41.84 125.75 42.14 121.55 42.27 117.51 41.98 117.15 38.4 117.49 34.81 121.95 34.38 122.02 30.27 117.5 29.99 112.66 29.92 112.59 34.25 113.16 38.39 113.14 42.53 112.99 46.52 117.12 46.79 121.41 46.7 125.7 46.77 129.99 46.68 134.28 46.87 138.57 46.38 142.78 46.6 142.7 42.42 142.75 38.16 142.9 33.91 143.06 29.65 142.77 25.39 142.55 21.13 142.8 16.87 142.84 12.63 138.15 12.4 138.59 16.83 138.5 21.05 138.18 25.27 138.42 29.5 138.03 33.72 138.2 37.94 138.45 42.27"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="127.6 22.46 122.81 22.35 117.98 22.5 113.05 22.31 113.16 26.9 117.97 26.93 122.81 26.87 127.73 27.01 127.6 22.46"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M151.1,17.11l3.45-.23,3.53.37v4.12L158,25.52l-.1,4.16.43,4.16L158,38l0,4-3.44.19-3.72-.18.38,4.38,4.17.5,4.41-.2,4.42-.09,4.41-.12,4.42,0,4.42.18.2-4.68-3.82,0-3.58.09,0-4.12-.09-4.16.32-4.16-.21-4.16-.07-4.16.12-4,3.48.18,3.5-.41.32-4.61-4.61,0-4.42.56-4.41-.61-4.42.29-4.42.11L151,12.76Zm14.74,25.15-3.46.1.33-4.35,0-4.16.06-4.16.11-4.16-.43-4.16.35-4.06h2.78l.22,4.06-.25,4.15.51,4.16-.6,4.16.19,4.16Z"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="194.25 36.99 191.54 39.7 190.83 34.99 194.23 32.08 194.24 32.09 194.21 25.54 190.29 29.23 189.73 25.33 189.38 21.18 188.53 17.07 188.38 12.78 183.72 13.31 184.4 17.54 184.56 21.75 185.65 25.84 185.79 30.05 186.36 34.2 187.1 38.34 187.55 42.51 188.11 46.6 191.43 45.12 194.29 43.32 194.25 36.99"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="205.21 43.73 202.12 40.43 200.08 37.91 197.34 40.2 194.29 43.32 194.25 36.99 197.22 34.35 199.85 31.23 201.93 34.02 205.2 37.88 205.21 43.73"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="205.31 32.16 202.45 29.36 200.21 26.99 194.23 32.08 194.21 25.54 199.73 21.13 205.41 26.54 205.31 32.16"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="210.61 12.67 210.02 16.98 210 21.13 209.16 25.19 208.91 29.24 205.41 26.54 205.31 32.16 208.04 34.88 207.78 39.61 205.2 37.88 205.21 43.73 208.2 44.94 211.26 46.89 211.75 42.53 212.3 38.37 212.74 34.2 213.17 30.03 213.71 25.87 214.3 21.72 214.57 17.52 215.12 13.51 210.61 12.67"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="223.97 42.32 224.22 36.59 227.99 36.34 231.79 36.68 235.59 36.66 239.46 36.63 239.62 31.87 235.59 32.2 231.79 31.75 227.99 31.79 224.36 31.83 224.26 29.4 227.99 29.4 231.79 29.43 235.59 28.99 239.54 29.44 239.36 24.82 235.59 25.05 231.79 24.91 227.99 24.55 224.07 24.92 223.91 21.03 224 17.03 228.61 17.32 233.03 17.4 237.45 17.43 241.88 17.18 246.46 17.42 246.22 12.82 241.87 12.8 237.43 12.63 232.99 12.58 228.56 12.9 224.12 12.63 219.65 12.72 219.75 16.99 219.68 21.23 219.8 25.47 219.87 29.71 219.95 33.95 219.82 38.19 219.64 42.43 219.69 46.67 223.63 46.65 227.59 46.81 231.54 46.68 235.5 46.47 239.45 46.53 243.41 46.69 247.44 46.74 247.23 42.28 243.5 42.29 239.64 41.93 235.78 42.27 231.92 42.02 228.06 42.38 223.97 42.32"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M110.68,64.47h2.5v8.87h-2.5Z"
              />
              <path
                className="fill-[#000] dark:fill-[#fff]"
                d="M127.42,68.9a4.83,4.83,0,1,1,4.83,4.6A4.77,4.77,0,0,1,127.42,68.9Zm7.07,0a2.25,2.25,0,1,0-2.24,2.32A2.31,2.31,0,0,0,134.49,68.9Z"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="40.07 46.7 34.43 37.08 43.15 19.34 67.25 13.19 72.18 20.9 70.55 22.32 73.64 23.2 75.97 26.83 73.92 41.14 62.63 46.7 40.07 46.7"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="61.46 49.25 76.28 47.9 82.45 53.28 81.64 64.77 65.7 71.3 55.68 64.03 58.09 53.07 61.46 49.25"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="91.46 40.7 91.36 44.81 89.34 41.24 85.23 41.14 88.81 39.12 88.9 35.01 90.92 38.59 95.03 38.68 91.46 40.7"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="18.57 58.16 18.47 62.27 16.45 58.69 12.34 58.6 15.92 56.58 16.01 52.47 18.04 56.05 22.14 56.14 18.57 58.16"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="26.74 55.37 21.61 59.02 45.97 52.98 26.74 55.37"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="84.54 39.57 81.85 41.73 70.95 44.81 84.54 39.57"
              />
              <polygon
                className="fill-[#000] dark:fill-[#fff]"
                points="97.65 35.01 97.09 36.72 96.18 35.16 94.46 34.59 96.03 33.69 96.6 31.97 97.5 33.53 99.22 34.1 97.65 35.01"
              />
            </svg>
          </a>
        </div>
        <div className="text-xs text-center lg:text-left dark:text-grey-border mt-8 lg:mt-4">
          <p>
            Use of this website (including any and all parts and components)
            constitutes your acceptance of these{" "}
            <Link to="/terms-and-conditions" className="text-jiwe-blue font-bold">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link to="/privacy-policy" className="text-jiwe-blue font-bold">
              Privacy Policy
            </Link>
          </p>
          <p className="my-4">
            &copy; Jiwe Interactive, {new Date().getFullYear()}
          </p>
        </div>
        <div className="lg:hidden">
          <SocialMediaIcons colour="#3A3E41" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
